import { render, staticRenderFns } from "./TwoDeviceServiceAccounts.vue?vue&type=template&id=b1dd1dfa&"
import script from "./TwoDeviceServiceAccounts.vue?vue&type=script&lang=js&"
export * from "./TwoDeviceServiceAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports